export default "__VITE_ASSET__Ca9HxTOM__"